import React from 'react'

import Icon from 'Pods/Shared/Icon/Icon'

function UserGdprMessage() {
  return (
    <div className="user-info-section">
      <div className="user-message">
        <Icon type={['fas', 'info-circle']} />
        <span>
          You need to review your
          {' '}
          <a href="/profile/settings#tab-settings-notifications" className="link--primary-dark">
            email notification preferences
          </a>
        </span>
      </div>
    </div>
  )
}

export default UserGdprMessage
